module.exports = __webpack_public_path__ + "static/Chona Selosa-597fe02153ead8a2235a8158f97fc32b.png";